import React from "react";
import { ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { SheetClose } from "@/components/ui/sheet";

interface EmptyCartProps {
  isInSheet?: boolean;
  message?: string;
}

export default function EmptyCart({
  isInSheet = false,
  message = "Looks like you haven't added any items to your cart yet.",
}: EmptyCartProps) {
  return (
    <div className='flex flex-1 flex-col items-center justify-center align-middle px-4 py-8'>
      <ShoppingCart className='h-12 w-12 text-muted-foreground mb-4' />
      <h2 className='text-2xl font-semibold mb-2'>Your cart is empty</h2>
      <p className='text-muted-foreground text-center mb-6 px-8'>{message}</p>

      {isInSheet ? (
        <SheetClose asChild>
          <Button asChild>
            <Link href='/rock-board/products'>Continue Shopping</Link>
          </Button>
        </SheetClose>
      ) : (
        <Button asChild>
          <Link href='/rock-board/products'>Continue Shopping</Link>
        </Button>
      )}
    </div>
  );
}
